import { createTheme } from "@mui/material";

/*
  Themes for the tooltips on the property cells
*/

export const tooltipsTheme = createTheme({
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: "white",
            color: "black",
            fontSize: "0.8rem",
            padding: "1rem",
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          },
        },
      },
    },
  });